import { createStore } from 'vuex'

const state = {
  props: null,
  instance: null,
}

const mutations = {
  setProps(state, val) {
    state.props = val
  },
  setInstance(state, proxy) {
    state.instance = proxy
  }
}

const store = createStore({
  state: state,
  mutations: mutations,
})

export default store
